<template>
  <div class="field is-grouped is-grouped-multiline p-2">
    <PlayerTag
      v-for="player in presentPlayers"
      :key="player.username"
      :player="player"
      :totalRounds="totalRounds"
      :roundNumber="roundNumber"
      :canClose="canClose && (!player.games || !player.games.length)"
      @close="$emit('onRemovePlayer', player)"
      @onToggleParticipate="$emit('onToggleParticipate', player, roundNumber)"
    />

    <PlayerTag
      v-show="showAbsent"
      v-for="player in absentPlayers"
      :key="player.username"
      :player="player"
      :totalRounds="totalRounds"
      :roundNumber="roundNumber"
      :canClose="canClose"
      @close="$emit('onRemovePlayer', player)"
      @onToggleParticipate="$emit('onToggleParticipate', player, roundNumber)"
    />

    <a
      v-if="absentPlayers.length"
      @click="showAbsent = !showAbsent"
      class="tag is-light"
    >
      {{ showAbsent ? "hide absent" : "...show absent" }}
      ({{ absentPlayers.length }})
    </a>
  </div>
</template>

<script>
import PlayerTag from "./PlayerTag.vue";

export default {
  components: { PlayerTag },
  name: "PlayerTags",

  props: {
    players: { type: Array, required: true },
    // roundNumber is unavailable when viewing players of the tournament
    // it's available when viewing players in a specific round
    roundNumber: { type: Number, required: false },
    totalRounds: { type: Number, required: true },
    canClose: { type: Boolean, default: false },
    hideAbsent: { type: Boolean, default: false },
  },

  data() {
    return {
      showAbsent: !this.hideAbsent,
    };
  },

  computed: {
    absentPlayers() {
      return this.players.filter(
        (player) =>
          !player.isParticipating &&
          !player.roundsParticipated &&
          (!player.games || player.games.length === 0)
      );
    },

    presentPlayers() {
      return this.players.filter(
        (player) =>
          player.isParticipating ||
          player.roundsParticipated > 0 ||
          player.games?.length > 0
      );
    },
  },
};
</script>

<style></style>
